export enum DeviceVendor {
  Yealink = 'Yealink',
  Polycom = 'Polycom',
  Poly = 'Poly',
}
